import { render, staticRenderFns } from "./SessionProjectEvaluation.vue?vue&type=template&id=082422d3&"
import script from "./SessionProjectEvaluation.vue?vue&type=script&lang=ts&"
export * from "./SessionProjectEvaluation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports